// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__Ubcyx","colCheckbox":"styles_colCheckbox__1L7Yh"};